package br.com.vvrefeicoes.portal.navigation

import br.com.vvrefeicoes.portal.domain.model.PermissionKeys

/** Mapa do `@SerialName` de cada rota para a chave de módulo que a libera. */
private val routePermissions: Map<String, String> =
    mapOf(
        "administracao/unidades" to PermissionKeys.COMPANIES,
        "ferramentas/empresas-cnpj" to PermissionKeys.CNPJ_EMPRESAS,
        "juridico/oficiais-e-tribunais" to PermissionKeys.JURIDICO,
        "administracao/usuarios" to PermissionKeys.USERS,
        "administracao/auditoria" to PermissionKeys.AUDIT,
        "organograma" to PermissionKeys.ORG_CHART,
        "operacional/painel" to PermissionKeys.OPERATIONAL_PANEL,
        "operacional/lancamentos" to PermissionKeys.OPERATIONAL_ENTRIES,
        "comunicados" to PermissionKeys.ANNOUNCEMENTS,
        "guias-e-manuais" to PermissionKeys.GUIDES_AND_MANUALS,
        "guias-e-manuais/{id}" to PermissionKeys.GUIDES_AND_MANUALS,
        "guias-e-manuais/novo" to PermissionKeys.GUIDES_AND_MANUALS,
        "guias-e-manuais/{id}/editar" to PermissionKeys.GUIDES_AND_MANUALS,
        "saude-do-sistema" to PermissionKeys.SYSTEM_HEALTH,
        "rh/painel" to PermissionKeys.RH_PANEL,
        "rh/lancamentos" to PermissionKeys.RH_ENTRIES,
        "comercial" to PermissionKeys.COMMERCIAL,
        "compras" to PermissionKeys.PURCHASES,
        "compras/lancamentos" to PermissionKeys.PURCHASES_ENTRIES,
        "rh/rmp" to PermissionKeys.RMP,
        "rh/novo-rmp" to PermissionKeys.RMP_REQUEST,
        "rh/rmp/{id}/editar" to PermissionKeys.RMP,
        "rh/rmp-sync" to PermissionKeys.RMP_ADMIN,
        "ferramentas/food-pass/clientes" to PermissionKeys.FOOD_PASS,
        "ferramentas/food-pass/consumos" to PermissionKeys.FOOD_PASS,
        "ferramentas/food-pass/faturamento" to PermissionKeys.FOOD_PASS,
        "ferramentas/redes-sociais" to PermissionKeys.SOCIAL_CONNECTIONS,
        "ferramentas/satisfaction/relatorios" to PermissionKeys.SATISFACTION,
        "ferramentas/satisfaction/status-operacao" to PermissionKeys.SATISFACTION,
        "formularios" to PermissionKeys.FORMULARIOS,
        "formularios/criar" to PermissionKeys.FORMULARIOS,
        "formularios/{id}" to PermissionKeys.FORMULARIOS,
        "formularios/editar/{id}" to PermissionKeys.FORMULARIOS,
    )

/** Sem permissão definida, a rota é pública (Início, Notificações, Política). */
fun canAccess(
    permissions: Set<String>,
    permission: String?,
): Boolean = permission == null || permission in permissions

fun canAccessRouteName(
    permissions: Set<String>,
    routeName: String,
): Boolean = routePermissions[routeName]?.let { it in permissions } ?: true
